import OrganizationIntegrationCampaignMonitor from './OrganizationIntegrationCampaignMonitor';
import OrganizationIntegrationComms from './OrganizationIntegrationComms';
import OrganizationIntegrationIdSmart from './OrganizationIntegrationIdSmart';
import OrganizationIntegrationLoanQ from './OrganizationIntegrationLoanQ';
import OrganizationIntegrationMailChimp from './OrganizationIntegrationMailChimp';
import OrganizationIntegrationPepperAssetFinance from './OrganizationIntegrationPepperAssetFinance';
import type { IOrganizationIntegrations } from './OrganizationIntegrations.interface';

export default class OrganizationIntegrations implements IOrganizationIntegrations {
  campaignMonitor: OrganizationIntegrationCampaignMonitor;
  comms: OrganizationIntegrationComms;
  idSmart: OrganizationIntegrationIdSmart;
  loanq: OrganizationIntegrationLoanQ;
  mailChimp: OrganizationIntegrationMailChimp;
  pepperAssetFinance: OrganizationIntegrationPepperAssetFinance;

  static build = (data: IOrganizationIntegrations) => new OrganizationIntegrations(data);
  static blank = () => new OrganizationIntegrations();

  /**
   * Constructor
   * @param {IOrganizationIntegrations} data
   */
  constructor(data?: IOrganizationIntegrations) {
    this.campaignMonitor = new OrganizationIntegrationCampaignMonitor(data?.campaignMonitor);
    this.comms = new OrganizationIntegrationComms(data?.comms);
    this.idSmart = new OrganizationIntegrationIdSmart(data?.idSmart);
    this.loanq = new OrganizationIntegrationLoanQ(data?.loanq);
    this.mailChimp = new OrganizationIntegrationMailChimp(data?.mailChimp);
    this.pepperAssetFinance = new OrganizationIntegrationPepperAssetFinance(
      data?.pepperAssetFinance
    );
  }
}
